import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=8fb1b0c0&"
import script from "./TasksView.vue?vue&type=script&lang=js&"
export * from "./TasksView.vue?vue&type=script&lang=js&"
import style0 from "./TasksView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports